import { createSlice } from '@reduxjs/toolkit';

const initialMenuItem = {
  name: 'dashboard',
  url: 'dashboard',
  id: 1,
  data: {},
  refetch: true,
};

const initialState = {
  menuItems: [initialMenuItem],
  activeMenu: initialMenuItem,
};

const Menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    addMenu(state, action) {
      const existing = state.menuItems.find(
        (item) => item.id === action.payload.id
      );

      if (!!existing) {
        const updated = { ...existing, ...action.payload, refetch: true };
        const index = state.menuItems.findIndex(
          (item) => item.id === action.payload.id,
        );
        state.menuItems[index] = updated;
        state.activeMenu = updated;
      } else {
        let tempProductItem = { ...action.payload, refetch: true };
        state.menuItems.push(tempProductItem);
        state.activeMenu = tempProductItem;
      }
    },

    removeFromMenu(state, action) {
      const { payload } = action;
      const nextActiveMenu = state.menuItems.find(
        (item) => item.url === payload?.nextUrl
      );
      if (nextActiveMenu) {
        state.activeMenu = nextActiveMenu;
        state.menuItems = state.menuItems.filter(
          (item) => item.id !== payload.id
        );
      }
    },

    replaceMenu(state, action) {
      const { payload } = action;
      const menuIndex = state.menuItems.findIndex(
        (item) => item.id === state.activeMenu.id
      );
      state.menuItems[menuIndex] = payload;
      state.activeMenu = payload;
    },

    setActiveMenu(state, action) {
      state.activeMenu = action.payload;
    },

    setMenu(state, action) {
      state.menuItems[0] = action.payload;
      state.activeMenu = action.payload;
    },
    clearMenu(state, action) {
      state.menuItems = [initialMenuItem];
      state.activeMenu = initialMenuItem;
    },
    setMenuData(state, action) {
      const { payload } = action;
      const existingIndex = state.menuItems.findIndex(
        (item) => item.id === payload.activeMenu.id
      );
      if (state.activeMenu.id === payload.activeMenu.id) {
        state.activeMenu.data = payload.data;
      }
      if (state.menuItems[existingIndex]) {
        state.menuItems[existingIndex].data = payload.data;
      }
    },
    setRefetch(state, action) {
      const { payload } = action;
      const existingIndex = state.menuItems.findIndex(
        (item) => item.id === payload.id
      );
      state.activeMenu = { ...payload, refetch: true };
      if (state.menuItems[existingIndex]) {
        state.menuItems[existingIndex].refetch = true;
      }
    },
    /**
     * Mark a tab as needing a refetch, without making it the active one.
     *
     * `setRefetch` does both, and the second half is a side effect nobody wants
     * when the flag is being set on a tab the admin is not looking at. Saving a
     * product sets it on the product *list* so the list is fresh next time it is
     * opened; with `setRefetch` that also made the list the active tab, and the
     * tab bar followed — so pressing Save on an edit threw the admin back to the
     * catalogue and remounted the form they were still working in.
     *
     * This was named and called from the product form before it existed here.
     * `Menu.actions.markRefetch` was therefore `undefined`, the export below
     * handed that undefined straight out, and dispatching it threw
     * "(0 , W.j6) is not a function" on every single product save.
     */
    markRefetch(state, action) {
      const { payload } = action;
      const existingIndex = state.menuItems.findIndex((item) => item.id === payload.id);
      if (state.menuItems[existingIndex]) {
        state.menuItems[existingIndex].refetch = true;
      }
      /* Only when it happens to be the tab in front of the reader. Writing it
         unconditionally would be `setRefetch` again by another name. */
      if (state.activeMenu?.id === payload.id) {
        state.activeMenu.refetch = true;
      }
    },
    disableRefetch(state, action) {
      const { payload } = action;
      const existingIndex = state.menuItems.findIndex(
        (item) => item.id === payload.id
      );
      state.activeMenu.refetch = false;
      if (state.menuItems[existingIndex]) {
        state.menuItems[existingIndex].refetch = false;
      }
    },
  },
});

export const {
  addMenu,
  removeFromMenu,
  setActiveMenu,
  setMenu,
  clearMenu,
  setMenuData,
  setRefetch,
  markRefetch,
  disableRefetch,
  replaceMenu,
} = Menu.actions;
export default Menu.reducer;
